import { X } from "lucide-react";

import { Loader2 } from "lucide-react";

export const AdminHeader = ({ title, subtitle, right }) => (
  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
    <div>
      <h1 className="font-display text-3xl font-extrabold text-white uppercase tracking-wide">{title}</h1>
      {subtitle && <p className="text-slate-400 mt-2">{subtitle}</p>}
    </div>
    {right}
  </div>
);

export const StatCard = ({ icon: Icon, label, value, color = "#00e5ff" }) => (
  <div className="glass rounded-2xl p-5 flex items-center gap-4">
    <div className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0"
      style={{ background: `${color}1f`, border: `1px solid ${color}55` }}>
      <Icon className="w-6 h-6" style={{ color }} />
    </div>
    <div>
      <p className="text-slate-400 text-xs uppercase tracking-widest">{label}</p>
      <p className="font-display text-2xl font-bold text-white">{value}</p>
    </div>
  </div>
);

export const TableWrap = ({ children }) => (
  <div className="glass rounded-2xl overflow-hidden">
    <div className="overflow-x-auto scrollbar-thin">
      <table className="w-full text-left text-sm">{children}</table>
    </div>
  </div>
);

export const Th = ({ children, className = "" }) => (
  <th className={`px-4 py-3.5 font-display text-xs uppercase tracking-widest text-slate-400 whitespace-nowrap ${className}`}>{children}</th>
);

export const Td = ({ children, className = "", ...rest }) => (
  <td className={`px-4 py-3.5 text-slate-200 whitespace-nowrap ${className}`} {...rest}>{children}</td>
);

export const Tr = ({ children }) => (
  <tr className="border-t border-white/5 hover:bg-white/5 transition-colors">{children}</tr>
);

export const StatusChip = ({ status }) => {
  const map = {
    confirmed: "#00ff9d", active: "#00e5ff", pending: "#ffb020",
    cancelled: "#ff2e97", completed: "#94a3b8", inactive: "#94a3b8",
    upcoming: "#00e5ff", admin: "#ff2e97", staff: "#8b5cf6", customer: "#00e5ff",
  };
  const color = map[status] || "#94a3b8";
  return (
    <span className="chip capitalize" style={{ background: `${color}18`, border: `1px solid ${color}55`, color }}>
      {status}
    </span>
  );
};

export const Spinner = ({ label }) => (
  <div className="flex items-center justify-center gap-3 py-16">
    <Loader2 className="w-6 h-6 animate-spin" style={{ color: "#ff2e97" }} />
    {label && <span className="text-slate-400 uppercase tracking-widest text-xs">{label}</span>}
  </div>
);

export const EmptyRow = ({ colSpan, text }) => (
  <tr><td colSpan={colSpan} className="px-4 py-12 text-center text-slate-500">{text}</td></tr>
);

export const Modal = ({ open, onClose, title, children, testId }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid={testId}>
      <div className="absolute inset-0 bg-black/75 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-lg glass rounded-2xl p-6 max-h-[90vh] overflow-y-auto scrollbar-thin animate-in-up">
        <div className="flex items-center justify-between mb-5">
          <h3 className="font-display text-xl font-bold text-white">{title}</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-white" data-testid="modal-close"><X className="w-6 h-6" /></button>
        </div>
        {children}
      </div>
    </div>
  );
};

export const Field = ({ label, children }) => (
  <div className="mb-4">
    <label className="block text-xs font-bold uppercase tracking-widest text-slate-400 mb-2">{label}</label>
    {children}
  </div>
);
